/* Plastics Co header search (pcos-*).
   Instant results from Shopify's predictive search: suggested searches, categories, help
   pages and products. Products are ranked so the size you typed comes first, and that
   size is shown with its own price and a link straight to it. Also: Rods / Sheets / Tubes
   scope, shape filters on the results, recent and popular searches before you type,
   arrow keys / Enter / Esc, and "/" to jump to the box from anywhere.
   The theme's own SearchBar (theme.js) is still attached to .header__search-bar-wrapper,
   so the events it listens for are stopped at this form and never reach it. */
(function () {
  if (window.PCOS) return;
  window.PCOS = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var RECENT_KEY = 'pcos-recent';
  var SHOWN = 6;
  var desktop = window.matchMedia('(min-width: 1000px)');

  var ICON_SEARCH = '<svg class="pcon-svg" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>';
  var ICON_CLOCK = '<svg class="pcon-svg" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg>';
  var ICON_LIST = '<svg class="pcon-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h10"/></svg>';
  var ICON_PAGE = '<svg class="pcon-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>';
  var ICON_TICK = '<svg class="pcon-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  var ICON_X = '<svg class="pcon-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function reEsc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : fmt.format(n); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  /* "30 mm" -> "30mm", so it matches variant titles such as "30mm dia x 500mm" */
  function normalise(q) { return q.replace(/(\d)\s+mm\b/gi, '$1mm').replace(/\s+/g, ' ').trim(); }
  function sizesIn(q) {
    var out = [], m, re = /(\d+(?:\.\d+)?)mm\b/gi;
    while ((m = re.exec(q))) out.push(m[1] + 'mm');
    return out;
  }
  /* "30mm" is in "30mm dia x 500mm" but not in "130mm" */
  function hasSize(text, size) {
    return new RegExp('(^|[^\\d.])' + reEsc(size) + '(?![a-z0-9])', 'i').test(text);
  }
  function shapeWordIn(q) {
    var m = /\b(rod|sheet|tube)s?\b/i.exec(q);
    return m ? m[1].toLowerCase() : '';
  }
  function typeParts(p) {
    return String(p.type || '').split('>').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function shapeOf(p) { var t = typeParts(p); return t.length ? t[t.length - 1] : ''; }
  function typeLabel(p) { var t = typeParts(p); return (t.length > 1 ? t.slice(1) : t).join(' · '); }
  function plural(s) { return /s$/i.test(s) ? s : s + 's'; }

  /* Bold the typed words in a title, without touching HTML entities */
  function highlight(text, words) {
    var html = esc(text);
    if (!words.length) return html;
    var re = new RegExp('(&[#\\w]+;)|(' + words.map(function (w) { return reEsc(esc(w)); }).join('|') + ')', 'gi');
    return html.replace(re, function (all, ent, word) { return ent ? ent : '<mark>' + word + '</mark>'; });
  }
  /* Shopify's suggestion markup, rebuilt from its text: typed part plain, completion bold */
  function styled(s) {
    var doc = new DOMParser().parseFromString(s.styled_text || esc(s.text), 'text/html');
    var out = '';
    [].forEach.call(doc.body.childNodes, function (n) {
      out += n.nodeName === 'MARK' ? esc(n.textContent) : '<b>' + esc(n.textContent) + '</b>';
    });
    return out || esc(s.text);
  }

  /* ---------- Recent searches (this browser only) ---------- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  }
  function setRecent(list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
  }
  function saveRecent(q) {
    q = normalise(q);
    if (q.length < 2) return;
    setRecent([q].concat(getRecent().filter(function (r) { return r.toLowerCase() !== q.toLowerCase(); })));
  }

  function init(form) {
    var wrapper = form.parentElement;
    var input = form.querySelector('.pcos__input');
    var scopeSel = form.querySelector('[data-pcos-scope]');
    var clearBtn = form.querySelector('[data-pcos-clear]');
    var panel = form.querySelector('[data-pcos-panel]');
    var idle = panel.querySelector('[data-pcos-idle]');
    var live = panel.querySelector('[data-pcos-live]');
    var recentBox = panel.querySelector('[data-pcos-recent]');
    var recentList = panel.querySelector('[data-pcos-recent-list]');
    var scrim = form.querySelector('[data-pcos-scrim]');
    var cache = {}, timer = null, ctrl = null, isOpen = false, active = -1, lastRaw = '', unscoped = false;

    /* Keep the theme's search script out of it (see header.liquid) */
    ['focusin', 'input', 'keydown', 'submit'].forEach(function (type) {
      form.addEventListener(type, function (e) { e.stopPropagation(); });
    });

    function setPlaceholder() {
      input.placeholder = desktop.matches ? input.getAttribute('data-long-placeholder') : 'Search, e.g. acetal rod 30mm';
    }
    setPlaceholder();
    if (desktop.addEventListener) desktop.addEventListener('change', setPlaceholder);

    /* ---------- Open / close and placement ---------- */
    function place() {
      var r = form.getBoundingClientRect();
      /* visualViewport shrinks when a phone keyboard is up; innerHeight doesn't on iOS */
      var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      if (desktop.matches) {
        panel.style.left = panel.style.width = panel.style.height = '';
        panel.style.setProperty('--pcos-max', Math.max(240, vh - r.bottom - 24) + 'px');
        var header = form.closest('.header');
        form.style.setProperty('--pcos-scrim-top', (header ? header.getBoundingClientRect().bottom : r.bottom) + 'px');
      } else {
        /* Phones and tablets: full width, down to the bottom of the screen */
        panel.style.left = -r.left + 'px';
        panel.style.width = document.documentElement.clientWidth + 'px';
        panel.style.height = Math.max(200, vh - panel.getBoundingClientRect().top) + 'px';
      }
    }
    function open() {
      if (!isOpen) {
        isOpen = true;
        panel.hidden = false;
        form.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
        if (desktop.matches) scrim.hidden = false;
        if (wrapper) wrapper.classList.add('pcos-raised');
      }
      place();
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      panel.hidden = true;
      scrim.hidden = true;
      form.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      if (wrapper) wrapper.classList.remove('pcos-raised');
      setActive(-1);
    }
    function showIdle() {
      renderRecent();
      idle.hidden = false;
      live.hidden = true;
      setActive(-1);
    }

    /* ---------- Recent searches ---------- */
    function renderRecent() {
      var list = getRecent();
      recentBox.hidden = !list.length;
      recentList.innerHTML = list.map(function (q) {
        return '<li><button type="button" class="pcos-rec" data-pcos-opt data-pcos-q="' + esc(q) + '">' + ICON_CLOCK + '<span>' + esc(q) + '</span></button>' +
          '<button type="button" class="pcos-rec__x" data-pcos-del="' + esc(q) + '" aria-label="Remove ' + esc(q) + ' from recent searches">' + ICON_X + '</button></li>';
      }).join('');
    }

    /* ---------- Keyboard: one list across the whole panel ---------- */
    function options() {
      return [].filter.call(panel.querySelectorAll('[data-pcos-opt]'), function (el) {
        return el.offsetParent !== null;
      });
    }
    function setActive(i) {
      var opts = options();
      opts.forEach(function (el, n) {
        if (!el.id) el.id = 'pcos-o-' + Math.random().toString(36).slice(2, 8);
        el.classList.toggle('is-active', n === i);
      });
      active = i >= 0 && i < opts.length ? i : -1;
      if (active > -1) {
        input.setAttribute('aria-activedescendant', opts[active].id);
        opts[active].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    /* ---------- Search ---------- */
    function scopedQuery(raw) {
      var s = scopeSel.value;
      return s && !unscoped && raw.toLowerCase().indexOf(s) === -1 ? raw + ' ' + s : raw;
    }
    function get(q, signal) {
      if (cache[q]) return Promise.resolve(cache[q]);
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query,page&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor' +
        '&resources[options][unavailable_products]=last';
      return fetch(url, signal ? { signal: signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) { return (cache[q] = (j.resources && j.resources.results) || {}); });
    }
    function empty(res) {
      return !(res.products || []).length && !(res.collections || []).length && !(res.queries || []).length;
    }

    function run() {
      var raw = normalise(input.value);
      clearBtn.hidden = !input.value;
      if (raw.length < 2) { lastRaw = ''; showIdle(); return; }
      if (raw === lastRaw && !live.hidden) return;
      lastRaw = raw;
      unscoped = false;
      var q = scopedQuery(raw);
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var signal = ctrl && ctrl.signal;
      form.classList.add('is-loading');
      get(q, signal)
        .then(function (res) {
          if (q === raw || (res.products || []).length) return res;
          /* Nothing in the chosen department: show everything rather than nothing */
          return get(raw, signal).then(function (all) {
            if (!empty(all)) unscoped = true;
            return empty(all) ? res : all;
          });
        })
        .then(function (res) {
          if (normalise(input.value) !== raw) return;
          form.classList.remove('is-loading');
          render(res, raw);
        })
        .catch(function () { form.classList.remove('is-loading'); });
    }

    /* Order: has every word typed (Shopify's fuzzy matching also returns near misses,
       e.g. PETG for "ptfe"), then is the shape asked for, then has the exact size */
    function rank(products, raw) {
      var sizes = sizesIn(raw);
      var shape = scopeSel.value || shapeWordIn(raw);
      var terms = raw.toLowerCase().split(' ').filter(function (w) {
        return w.length > 1 && !/^\d/.test(w) && !/^(rod|sheet|tube)s?$/.test(w);
      });
      return products.map(function (p, i) {
        var hay = (p.title + ' ' + (p.type || '') + ' ' + (p.vendor || '')).toLowerCase();
        var allTerms = terms.length > 0 && terms.every(function (w) { return hay.indexOf(w.replace(/s$/, '')) > -1; });
        var best = null, bestHits = 0;
        if (sizes.length) {
          (p.variants || []).forEach(function (v) {
            var hits = sizes.filter(function (s) { return hasSize(v.title, s); }).length;
            if (hits > bestHits) { best = v; bestHits = hits; }
          });
        }
        var shapeHit = shape && shapeOf(p).toLowerCase().indexOf(shape) === 0;
        return { p: p, v: best, score: (allTerms ? 10 : 0) + (shapeHit ? 6 : 0) + (bestHits ? Math.min(3 + bestHits, 5) : 0) + (p.available === false ? -20 : 0), i: i };
      }).sort(function (a, b) { return b.score - a.score || a.i - b.i; });
    }

    function render(res, raw) {
      var words = raw.split(' ').filter(function (w) { return w.length > 1; });
      var ranked = rank(res.products || [], raw);
      var side = '', main = '';

      (res.queries || []).slice(0, desktop.matches ? 6 : 4).forEach(function (s, n) {
        if (n === 0) side += '<p class="pcos-h">Suggestions</p><ul class="pcos-list" role="list">';
        side += '<li><a class="pcos-sug" data-pcos-opt data-pcos-save href="' + esc(s.url) + '">' + ICON_SEARCH + '<span>' + styled(s) + '</span></a></li>';
      });
      if ((res.queries || []).length) side += '</ul>';
      (res.collections || []).slice(0, 4).forEach(function (c, n) {
        if (n === 0) side += '<p class="pcos-h">Categories</p><ul class="pcos-list" role="list">';
        side += '<li><a class="pcos-sug pcos-sug--cat" data-pcos-opt data-pcos-save href="' + esc(c.url) + '">' + ICON_LIST + '<span>' + highlight(c.title, words) + '</span></a></li>';
      });
      if ((res.collections || []).length) side += '</ul>';
      (res.pages || []).slice(0, 2).forEach(function (pg, n) {
        if (n === 0) side += '<p class="pcos-h">Help &amp; info</p><ul class="pcos-list" role="list">';
        side += '<li><a class="pcos-sug" data-pcos-opt href="' + esc(pg.url) + '">' + ICON_PAGE + '<span>' + esc(pg.title) + '</span></a></li>';
      });
      if ((res.pages || []).length) side += '</ul>';

      if (ranked.length) {
        /* Shape filters, when the results span more than one */
        var counts = {}, order = [];
        ranked.forEach(function (r) {
          var s = shapeOf(r.p) || 'Other';
          if (!counts[s]) { counts[s] = 0; order.push(s); }
          counts[s]++;
        });
        var facets = '';
        if (order.length > 1) {
          facets = '<div class="pcos-facets" role="group" aria-label="Filter by shape"><button type="button" class="pcos-facet is-on" data-pcos-facet="">All</button>' +
            order.map(function (s) {
              return '<button type="button" class="pcos-facet" data-pcos-facet="' + esc(s) + '">' + esc(plural(s)) + ' <span>' + counts[s] + '</span></button>';
            }).join('') + '</div>';
        }
        main += '<div class="pcos-results__head"><p class="pcos-h">Products</p>' + facets + '</div><ul class="pcos-prods" role="list">';
        ranked.forEach(function (r) {
          var p = r.p, v = r.v;
          var min = parseFloat(p.price_min || p.price), max = parseFloat(p.price_max || p.price);
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          main += '<li class="pcos-prod" data-shape="' + esc(shapeOf(p) || 'Other') + '">' +
            '<a class="pcos-prod__a" data-pcos-opt data-pcos-save href="' + esc(p.url) + '">' +
              '<span class="pcos-prod__img">' + (img ? '<img src="' + esc(sized(img, 128)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
              '<span class="pcos-prod__tx"><span class="pcos-prod__t">' + highlight(p.title, words) + '</span>' +
                '<span class="pcos-prod__m">' + esc(typeLabel(p)) + (p.available === false ? ' · <em>Currently unavailable</em>' : '') + '</span></span>' +
              (isNaN(min) ? '' : '<span class="pcos-prod__p">' + (max > min ? '<small>From</small>' : '') + money(min) + '</span>') +
            '</a>' +
            (v ? '<a class="pcos-size" data-pcos-opt data-pcos-save href="' + esc(v.url) + '">' + ICON_TICK +
              '<span><em>Your size:</em> ' + esc(v.title) + '</span><b>' + money(v.price) + '</b></a>' : '') +
          '</li>';
        });
        main += '</ul>';
      }

      var html;
      if (!side && !main) {
        html = '<div class="pcos-none"><p class="pcos-none__t">No matches for “' + esc(raw) + '”</p>' +
          '<p>Check the spelling, or search by material, e.g. acetal, PTFE or HDPE. Trade names such as Delrin, Perspex and Teflon work too.</p></div>';
      } else {
        html = '<div class="pcos-live' + (side ? '' : ' pcos-live--solo') + '">' +
          (side ? '<div class="pcos-live__side">' + side + '</div>' : '') +
          '<div class="pcos-live__main">' + main +
            '<button type="submit" class="pcos-all" data-pcos-opt>See all results for “' + esc(unscoped || !scopeSel.value ? raw : scopedQuery(raw)) + '”</button>' +
          '</div></div>';
      }
      live.innerHTML = html;
      idle.hidden = true;
      live.hidden = false;
      applyFacet('');
      setActive(-1);
      /* Results that land after the shopper has clicked away shouldn't pop back up */
      if (form.contains(document.activeElement)) open();
    }

    function applyFacet(shape) {
      var n = 0;
      [].forEach.call(live.querySelectorAll('.pcos-prod'), function (li) {
        var match = !shape || li.getAttribute('data-shape') === shape;
        li.hidden = !match || n >= SHOWN;
        if (match) n++;
      });
      [].forEach.call(live.querySelectorAll('[data-pcos-facet]'), function (b) {
        var on = b.getAttribute('data-pcos-facet') === shape;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function fill(q) {
      input.value = q;
      lastRaw = '';
      input.focus();
      run();
    }

    /* ---------- Events ---------- */
    input.addEventListener('focus', function () {
      if (normalise(input.value).length >= 2 && live.innerHTML && lastRaw === normalise(input.value)) {
        idle.hidden = true; live.hidden = false;
      } else if (normalise(input.value).length >= 2) {
        lastRaw = ''; run();
      } else {
        showIdle();
      }
      open();
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      clearBtn.hidden = !input.value;
      timer = setTimeout(run, 120);
    });
    input.addEventListener('keydown', function (e) {
      var opts;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!isOpen) { open(); return; }
        opts = options();
        if (!opts.length) return;
        e.preventDefault();
        var d = e.key === 'ArrowDown' ? 1 : -1;
        var next = active + d;
        if (next < -1) next = opts.length - 1;
        if (next >= opts.length) next = -1;
        setActive(next);
      } else if (e.key === 'Enter' && active > -1) {
        opts = options();
        if (opts[active]) { e.preventDefault(); opts[active].click(); }
      } else if (e.key === 'Escape') {
        if (isOpen) { e.preventDefault(); close(); }
        else if (input.value) { input.value = ''; clearBtn.hidden = true; }
      } else if (e.key === 'Tab') {
        close();
      }
    });

    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      lastRaw = '';
      input.focus();
      showIdle();
      open();
    });

    scopeSel.addEventListener('change', function () {
      lastRaw = '';
      input.focus();
      if (normalise(input.value).length >= 2) run();
    });

    panel.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pcos-q], [data-pcos-del], [data-pcos-clear-recent], [data-pcos-facet], [data-pcos-save]');
      if (!t) return;
      if (t.hasAttribute('data-pcos-q')) {
        e.preventDefault();
        fill(t.getAttribute('data-pcos-q'));
      } else if (t.hasAttribute('data-pcos-del')) {
        var q = t.getAttribute('data-pcos-del');
        setRecent(getRecent().filter(function (r) { return r !== q; }));
        renderRecent();
        input.focus();
      } else if (t.hasAttribute('data-pcos-clear-recent')) {
        setRecent([]);
        renderRecent();
        input.focus();
      } else if (t.hasAttribute('data-pcos-facet')) {
        applyFacet(t.getAttribute('data-pcos-facet'));
        setActive(-1);
      } else {
        saveRecent(input.value);
      }
    });
    /* Keep focus in the box when clicking panel buttons, so it stays open */
    panel.addEventListener('mousedown', function (e) {
      if (e.target.closest('button')) e.preventDefault();
    });

    form.addEventListener('submit', function (e) {
      var raw = normalise(input.value);
      if (!raw) { e.preventDefault(); input.focus(); return; }
      saveRecent(raw);
      input.value = scopedQuery(raw);
    });

    scrim.addEventListener('click', close);
    form.querySelector('[data-pcos-cancel]').addEventListener('click', function () {
      close();
      input.blur();
    });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (isOpen) place(); });
    document.addEventListener('pointerdown', function (e) {
      if (isOpen && !form.contains(e.target)) close();
    });
    form.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !form.contains(e.relatedTarget)) close();
    });
    window.addEventListener('resize', function () { if (isOpen) place(); });
    window.addEventListener('scroll', function () { if (isOpen) place(); }, { passive: true });

    /* "/" jumps to the search box, as on GitHub and YouTube */
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (!input.offsetParent) return;
      e.preventDefault();
      input.focus();
      input.select();
    });

    /* If "Minimise search on mobile" is switched back on, the theme's search icon reveals
       this bar; put the cursor straight in it (same tap, so phones open the keyboard) */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-action="toggle-search"]') && wrapper && wrapper.classList.contains('is-visible')) input.focus();
    });

    clearBtn.hidden = !input.value;
    if (wrapper) wrapper.classList.add('pcos-host');
  }

  function start() { [].forEach.call(document.querySelectorAll('[data-pcos]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
